module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0693.caaf3b18.jpg";